// extracted by mini-css-extract-plugin
export default {"main":"input_main__AoKIR","inputs":"input_inputs__zOwmw","prefisso":"input_prefisso__R7jMw"};